import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const heading = css`
  margin-bottom: var(--space-200);
`;

export const content = css`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: var(--space-500) var(--space-400);
  width: 100%;
  padding: var(--space-500) 0 var(--space-1000);
  ${breakpoints.to.desktop} {
    grid-template-columns: 1fr 1fr;
  }
  ${breakpoints.to.tablet} {
    grid-template-columns: 1fr;
  }
`;

export const contentWithCharSelected = css`
  display: block;
`;
